import React from 'react';
import { Link } from 'react-router-dom';
import { LoanProduct } from '../types';

interface LoanProductCardProps {
  product: LoanProduct;
}

export const LoanProductCard: React.FC<LoanProductCardProps> = ({ product }) => {
  return (
    <div className="loan-product-card">
      <div className="card-header">
        <h3>{product.product_name}</h3>
        <span className="product-type">{product.product_type}</span>
      </div>

      <div className="card-body">
        <p className="description">{product.description}</p>

        <div className="product-details">
          <div className="detail-item">
            <span className="label">Amount Range:</span>
            <span className="value">
              {Number(product.min_amount).toLocaleString()} - {Number(product.max_amount).toLocaleString()}
            </span>
          </div>

          <div className="detail-item">
            <span className="label">Term:</span>
            <span className="value">
              {product.min_term_months} - {product.max_term_months} months
            </span>
          </div>

          <div className="detail-item">
            <span className="label">Interest Rate:</span>
            <span className="value">
              {Number(product.min_interest_rate).toFixed(1)}% - {Number(product.max_interest_rate).toFixed(1)}%
            </span>
          </div>

          <div className="detail-item">
            <span className="label">Processing Fee:</span>
            <span className="value">{Number(product.processing_fee_percentage).toFixed(1)}%</span>
          </div>
        </div>

        <div className="requirements">
          {product.requires_collateral && (
            <span className="requirement-badge">Collateral Required</span>
          )}
          {product.requires_guarantor && (
            <span className="requirement-badge">Guarantor Required</span>
          )}
        </div>
      </div>

      <div className="card-footer">
        <Link to="/customer/applications/new" state={{ product }} className="btn btn-primary">
          Apply Now
        </Link>
      </div>
    </div>
  );
};
